import React, { useEffect, useState } from 'react'

import SetupTile from '../components/tiles/SetupTile'
import AddNewTile from '../components/tiles/AddNewTile'
import useRole from '../useUserRole'

import statisticsApi from '../api/statistics'
import useHandleError from '../api/useHandleError'
import { StatisticsPageMain, StatisticsPageTilesGrid, StatisticsPageTitle } from '../styles/pages/StatisticsPageStyle'
import { setViewportWidth } from '../useViewPort'

const StatisticsPage = () => {
  const { userRole } = useRole()
  const [tiles, setTiles] = useState([])
  const handleError = useHandleError()
  setTimeout(() => setViewportWidth())

  const getTiles = () => {
    return statisticsApi
      .listNames()
      .then((data) => data.data.results)
      .catch(handleError)
  }

  useEffect(() => {
    const fetchTiles = async () => {
      const tilesData = await getTiles()
      setTiles(tilesData)
    }
    fetchTiles()
  }, [])

  const renderTiles = (tilesList) =>
    tilesList &&
    tilesList.length !== 0 &&
    tilesList.map((tile, index) => (
      <SetupTile key={tile.id} index={index} id={tile.id} title={tile.name} tiles={tilesList} setTiles={setTiles} />
    ))

  return (
    <StatisticsPageMain>
      <StatisticsPageTitle variant="h4" component="h1">
        Select statistics configuration to display
      </StatisticsPageTitle>
      <StatisticsPageTilesGrid aria-label="tilesGrid">
        {renderTiles(tiles)}
        {userRole === 'admin' && <AddNewTile tiles={tiles} setTiles={setTiles} />}
      </StatisticsPageTilesGrid>
    </StatisticsPageMain>
  )
}

export default StatisticsPage
